import { useMemo } from 'react';
import { InitValues, SelectedOrgUnit } from './types';
import { useAuth } from 'src/state/auth';
import { Role } from 'src/graphql/_generated';

type UseInitialValues = (params: { selectedOrgUnit?: SelectedOrgUnit; isReady: boolean }) => {
  initError: string;
  initialValues: InitValues;
};

const useInitialValues: UseInitialValues = ({ selectedOrgUnit, isReady }) => {
  const { profile } = useAuth();

  console.log('selectedOrgUnit.member', selectedOrgUnit?.member);

  return useMemo(() => {
    if (!profile || !isReady) {
      return {
        initError: '',
        initialValues: {
          name: '',
          email: '',
        },
      };
    }

    // GLOBAL SELF - use profile data
    if (!selectedOrgUnit) {
      return {
        initError: '',
        initialValues: {
          name: profile.user.name,
          profilePhotoPath: profile.user.profilePhotoPath,
          email: profile.user.email,
          defaultName: profile.user.name,
          receiveNotifications: !!profile.user.receiveNotifications,
        },
      };
    }

    const association = selectedOrgUnit.member?.association;

    if (association) {
      return {
        initError: '',
        initialValues: {
          name: association.userName || '',
          profilePhotoPath: selectedOrgUnit.member?.user?.profilePhotoPath || null,
          email: association.userEmail || '',
          defaultName: association.userName || '',
          acceptedDate: association.acceptedDate,
          receiveNotifications: association.notifications,
          role: association.role || Role.Collaborator,
        },
      };
    }

    return {
      initError: 'User not found',
      initialValues: {
        name: selectedOrgUnit.member?.user?.name || '',
        defaultName: selectedOrgUnit.member?.user?.name || '',
        profilePhotoPath: selectedOrgUnit.member?.user?.profilePhotoPath || null,
        email: selectedOrgUnit.member?.user?.email || '',
      },
    };
  }, [selectedOrgUnit, profile, isReady]);
};

export default useInitialValues;
